module.exports = __webpack_public_path__ + "media/images/mobile-newsletter-5d3b89ff1a82e70096d2a00c071a4861.png";